import React, { forwardRef, useMemo, useState } from "react"
import DatePicker, { registerLocale } from "react-datepicker"
import styled from "styled-components"
import lv from "date-fns/locale/lv"
import en from "date-fns/locale/en-US"
import "./DatePickerInput.css"
import { useTranslation } from "react-i18next"
import HyperDiv from "components/ProjectNonSpecificComponents/Elements/HyperDiv/HyperDiv"
import IconButton from "./Buttons/IconButton"
import concatWithSpaces from "components/ProjectNonSpecificComponents/Functions/concatWithSpaces"
import { USER_REQ_CLASSNAME } from "../../AdminForm/organisms/UserSubmitRequest"
require("react-datepicker/dist/react-datepicker.css")
interface Props {
	onChangeDate?: (date: string) => void
	value?: string
	isRequired?: boolean
}
const DatePickerInput = ({ onChangeDate = () => {}, value, isRequired = false }: Props) => {
	const { t } = useTranslation()
	registerLocale("lv", lv)
	registerLocale("en", en)

	const CustomDateInput = forwardRef(({ value, onClick }: any, ref: any) => (
		<DateButton
			style={{ width: "100%" }}
			className={concatWithSpaces(isRequired ? USER_REQ_CLASSNAME : "", "pointer")}
			onClick={onClick}
			ref={ref}
		>
			<HyperDiv
				direction="row"
				padding="0 16px"
				spaceBetweenElems=".75rem"
				style={{ overflow: "hidden" }}
				centered
			>
				<HyperDiv hidesOverflownText>{value ? value : t("date-picker.date-format")}</HyperDiv>
				<IconButton
					iconWidth={15}
					iconHeight={15}
					iconKey="calendar"
					iconColor={"var(--light-gray)"}
					iconColorOnHover={"var(--light-gray)"}
				/>
			</HyperDiv>
		</DateButton>
	))

	const dateState = useMemo(() => {
		if (value) return new Date(value)
	}, [value])

	const updateDate = (date: any) => {
		const selectedDate = new Date(date)
		// Turns selected date in milliseconds
		const selectedDateInMilliseconds = selectedDate.getTime()
		// Gets timezone offset in minutes and turns into milliseconds
		const timezoneOffset = selectedDate.getTimezoneOffset() * 60000
		// Timezones causes to get wrong date when using toISOString so timezone have to be removed
		const isoDateTime = new Date(selectedDateInMilliseconds - timezoneOffset)
			.toISOString()
			.substring(0, 10)
		onChangeDate(isoDateTime)
	}

	return (
		<DatePicker
			locale={t("date-picker.selected-language")}
			selected={value ? dateState : undefined}
			onChange={updateDate}
			customInput={<CustomDateInput />}
			popperPlacement="bottom"
			showPopperArrow={false}
			dateFormat="dd/MM/yyyy"
		/>
	)
}

export default DatePickerInput
const DateButton = styled.button`
	height: 38px;
	padding: 0 16px;
	background-color: var(--white);
	outline-color: var(--blue);
	border-radius: 5px;
	border: 1px solid var(--gray-c2);

	// Text
	color: inherit;
	font-family: inherit;
	font-size: 14px;
	font-weight: 400;
	line-height: 1.6;
	text-transform: none;
	word-wrap: normal;

	// Animation
	transition: 0.2s var(--default-slide-transition-fn);
	transition-property: border-color;
`
